module.exports = __webpack_public_path__ + "img/skala-1863.7f9dbf11.png";